import * as React from 'react';
import {RegisterNamesScreenType} from '@practicegenius/register-account/src/screens/RegisterNames';
import {Input} from '@practicegenius/pg-ui/src/base/Material/components/Input';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {InlineError} from '../../../components/InlineError';
import {loginBottomText} from '../components/layout';

export const RegisterNames: RegisterNamesScreenType = ({
  lang,
  onFormSubmit,
  progress,
  actionButtons,
  firstnameInputProps,
  lastnameInputProps,
  cardNumberValidationError,
}) => (
  <form onSubmit={onFormSubmit}>
    <ProgressScreen
      helmetTitle={lang.pageTitle}
      headerTitle={lang.headerTitle}
      title={lang.title}
      progress={progress}
      actionButtons={[actionButtons.primary, actionButtons.secondary]}
      cancelProps={{href: '/'}}
      bottomText={loginBottomText}
    >
      <Input
        type="text"
        name="firstname"
        value={firstnameInputProps.value ?? ''}
        onChange={e => firstnameInputProps.onChange(e.target.value)}
        onBlur={firstnameInputProps.onBlur}
        label={lang.firstnameInput.label}
        error={firstnameInputProps.error}
        autoFocus
      />

      <Input
        type="text"
        name="lastname"
        value={lastnameInputProps.value ?? ''}
        onChange={e => lastnameInputProps.onChange(e.target.value)}
        onBlur={lastnameInputProps.onBlur}
        label={lang.lastnameInput.label}
        error={lastnameInputProps.error}
      />

      <InlineError error={cardNumberValidationError} />
    </ProgressScreen>
  </form>
);
